var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recommend_activity_page" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { name: "table" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("i", { staticClass: "el-icon-list" }),
                _vm._v(" 活动列表\n      "),
              ]),
              _vm._v(" "),
              _c("recommend-activity-table-pane", {
                ref: "recommendActivityTable",
                on: {
                  addActivity: _vm.handleAddActivity,
                  editActivity: _vm.handleEditActivity,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { name: "config", disabled: !_vm.activityId } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("i", { staticClass: "el-icon-setting" }),
                _vm._v(" 活动配置\n      "),
              ]),
              _vm._v(" "),
              _vm.activeName === "config"
                ? _c("recommend-activity-config-pane", {
                    ref: "recommendActivityConfig",
                    attrs: { "activity-id": _vm.activityId },
                    on: { success: _vm.handleSuccess },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }